import React from "react";
import "./TwoTableLayout.scss";

const TwoTableLayout = ({ leftTable, rightTable }) => {
  const renderTable = (table, side) => {
    const { title, columns, data, emptyMessage = '', rowKey, keyExtractor, reverse, onRowClick } = table;
    
    return (
      <div className={`table_${side}`}>
        <div className="title_table">{title}</div>
        {data.length === 0 ? (
          <div className="no_items">{emptyMessage}</div>
        ) : (
          <div className="table_container table_columns">
            <div className="table_header">
              <div className={`table_row`}>
                {columns.map((col, idx) => (
                  <div 
                    key={idx} 
                    className="row_item" 
                    style={col.style}
                  >
                    {col.title}
                  </div>
                ))}
              </div>
            </div>
            <div className={`table_body ${reverse ? 'reverse' : ''}`}>
              {data.map((item, idx) => (
                <div 
                  className={`table_row ${onRowClick ? 'clickable' : ''}`} 
                  key={keyExtractor ? keyExtractor(item, idx) : (rowKey ? item[rowKey] : idx)}
                  onClick={onRowClick ? () => onRowClick(item, idx) : undefined}
                  style={onRowClick ? { cursor: 'pointer' } : {}}
                >
                  {columns.map((col, colIdx) => (
                    <div 
                      key={colIdx} 
                      className="row_item" 
                      style={col.style}
                    >
                      {col.render ? col.render(item, idx) : item[col.field]}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="two_table_layout__root">
      {renderTable(leftTable, "left")}
      <div className="line_v" />
      {renderTable(rightTable, "right")}
    </div>
  );
};

export default TwoTableLayout;

